import $ from "jquery"
import "slick-carousel-latest"
import "jquery-match-height";

// Trust Slider
$('.js-why-trust-item').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }
    ]
});

// Product Slider
$('.js-product-list').on('init', function(event, slick) {
    $('.js-product-matchheight').matchHeight();
});

$('.js-product-list').on('afterChange', function(event, slick) {
    $('.js-product-matchheight').matchHeight();
});

$('.js-product-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// Reviews Slider
$('.js-reviews-lists').on('init', function(event, slick) {
    $('.js-reviews-matchheight').matchHeight();
    $('.js-reviews-count-current').text(slick.currentSlide + 1);
});

$('.js-reviews-lists').on('afterChange', function(event, slick) {
    $('.js-reviews-matchheight').matchHeight();
    $('.js-reviews-count-current').text(slick.currentSlide + 1);
});

$('.js-reviews-lists').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '.reviews__count-nav--prev',
    nextArrow: '.reviews__count-nav--next',
    centerMode: true,
    centerPadding: '15px',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {  breakpoint: 992,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});